import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { fetchLimitsData, clearLimitsData, updateStatusConfiguration } from '../actions';
import { useProjectManager } from './useProjectManager';

export const useLimitsData = () => {
  const dispatch = useDispatch();
  
  const {
    limitsData,
    limitsLoading,
    limitsError,
    statusCalculationMethod
  } = useSelector(state => ({
    limitsData: state.weldData?.limitsData || [],
    limitsLoading: state.weldData?.limitsLoading || false,
    limitsError: state.weldData?.limitsError || null,
    statusCalculationMethod: state.weldData?.statusCalculationMethod || 'Instantaneous'
  }));

  // Use centralized project manager
  const { projectId, projectName, isProjectReady } = useProjectManager();

  const loadLimitsData = useCallback(() => {
    console.log('🔍 useLimitsData - loadLimitsData called:', {
      isProjectReady,
      projectId,
      projectName
    });
    
    if (!isProjectReady || !projectId) {
      console.warn('⚠️ useLimitsData - Not ready to load limits:', {
        isProjectReady,
        projectId,
        projectName
      });
      return;
    }
    
    console.log('✅ useLimitsData - Dispatching fetchLimitsData with projectId:', projectId);
    dispatch(fetchLimitsData(projectId));
  }, [dispatch, projectId, projectName, isProjectReady]);

  const resetLimitsData = useCallback(() => {
    dispatch(clearLimitsData());
  }, [dispatch]);

  // Log status calculation method when it changes
  React.useEffect(() => {
    if (statusCalculationMethod) {
      // Status calculation method updated
    }
  }, [statusCalculationMethod]);

  return {
    limitsData,
    limitsLoading,
    limitsError,
    statusCalculationMethod,
    loadLimitsData,
    resetLimitsData
  };
};

export const useUpdateStatusConfiguration = () => {
  const dispatch = useDispatch();
  
  const {
    statusConfiguration,
    statusConfigurationLoading,
    statusConfigurationError,
    statusConfigurationSuccess
  } = useSelector(state => ({
    statusConfiguration: state.weldData?.statusConfiguration || {},
    statusConfigurationLoading: state.weldData?.statusConfigurationLoading || false,
    statusConfigurationError: state.weldData?.statusConfigurationError || null,
    statusConfigurationSuccess: state.weldData?.statusConfigurationSuccess || false
  }));

  const updateStatusConfigurationAction = useCallback((projectId, payload) => {
    dispatch(updateStatusConfiguration({ projectId, payload }));
  }, [dispatch]);

  const reset = useCallback(() => {
    // Reset function can be implemented if needed
  }, []);

  return {
    updateStatusConfiguration: updateStatusConfigurationAction,
    loading: statusConfigurationLoading,
    error: statusConfigurationError,
    success: statusConfigurationSuccess,
    reset
  };
};
